export default {
  LuvStoryCard__ARIA_LABEL_CURRENT_PAGE: "The current page is",
  LuvStoryCard__ARIA_LABEL_FOCUS_CHANGE_NEXT:
    "First page; focus will move to the next page button.",
  LuvStoryCard__ARIA_LABEL_FOCUS_CHANGE_PREVIOUS:
    "Final page; focus will move to the previous page button.",
  LuvStoryCard__ARIA_LABEL_NEXT: "Press this button to display the next page of items.",
  LuvStoryCard__ARIA_LABEL_PAGE_COUNT: "Total number of pages",
  LuvStoryCard__ARIA_LABEL_PREVIOUS: "Press this button to display the previous page of items.",
};
